import React from 'react';
import styled from 'styled-components';

// Components
import { MaskedInput } from 'wg-fe-ui';

// Types
import { Change } from '../../../../../../../types/Form';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}

const MaskedInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value, onChange, onBlur },
    prefilled,
    error,
  } = useFlowInputComponent({ question });

  return (
    <StyledMaskedInput
      name={question.id}
      onChange={({ name, value }: Change) =>
        onChange({ name, value: (value as string)?.replaceAll('.', '') })
      }
      onBlur={(e: React.FormEvent<HTMLInputElement>) => {
        onBlur({
          name: question.id,
          value: (e.currentTarget.value as string)?.replaceAll('.', ''),
        });
      }}
      error={error?.message}
      value={value}
      type={question.rules.data_type?.toLowerCase() || 'text'}
      data-test-id="ProdFac_MaskedInputComponent"
      prefilled={prefilled}
      mask="9999.999.999"
      disabled={question.rules.is_disabled}
    />
  );
};

const StyledMaskedInput = styled(MaskedInput)`
  height: fit-content;

  > label > input {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
      0 0 1px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    margin-top: 0;
    height: 4.5rem;
    padding-left: 1.2rem;

    ${({ prefilled }) =>
      prefilled ? `border-color: #FFBC0F; background-color: #FFF9EA;` : ''}
  }

  > div {
    margin-bottom: 0;
  }
`;

export default MaskedInputComponent;
